<script>
import modal from '@/components/view/modal'
import videoPlayer from '@/components/view/video-player'
export default {
  components: {
    'gp-modal': modal,
    'video-player': videoPlayer
  },
  computed: {
    hash () {
      return this.$route.hash.replace('#', '')
    }
  }
}
</script>
<template>
  <div class="gp-music">
    <div class="page-background"></div>
    <header>
      <h1 class="page-title">MUSIC</h1>
    </header>
    <div class="contents-container">
      <section class="tv has-text-weight-bold has-text-align-center">
        <h1 class="is-size-2 is-size-4-mobile">
          <span>オープニング・テーマ楽曲</span>
        </h1>
        <h2>
          <span>「G.P.」</span>
        </h2>
        <h3 class="is-size-1-mobile">
          <span>作曲 やまだ豊</span>
        </h3>
        <div class="video">
          <a href="#009" class="video is-small">
            <figure><img src="/assets/images/pv-poster9.jpg" alt="ノンクレジットOP"></figure>
          </a>
        </div>
      </section>
      <section class="tv has-text-weight-bold has-text-align-center">
        <h1 class="is-size-2 is-size-4-mobile">
          <span>主題歌</span>
        </h1>
        <h2>
          <a
            href="https://umj.lnk.to/great-pretender"
            target="_blank"
            rel="noopener"
          ><span>「The Great Pretender」</span></a>
        </h2>
        <h3 class="is-size-1-mobile">
          <span>Performed by Freddie Mercury<br>Words & Music by Buck Ram</span>
        </h3>
        <p class="is-size-2 is-size-3-mobile">
          ストリーミング・ダウンロード<br>
          <a
            href="https://umj.lnk.to/great-pretender"
            target="_blank"
            rel="noopener"
          >https://umj.lnk.to/great-pretender</a>
        </p>
        <div class="video">
          <a href="#008" class="video is-small">
            <figure><img src="/assets/images/pv-poster8.jpg" alt="ノンクレジットED"></figure>
          </a>
        </div>
        <div class="lyric-button">
          <a href="#lyric">
            <button class="is-size-2 is-size-3-mobile has-text-weight-bold">歌詞対訳はこちら</button>
          </a>
        </div>
      </section>
      <section class="soundtrack has-text-weight-bold has-text-align-center">
        <h1 class="is-size-2 is-size-4-mobile">
          <span>オリジナルサウンドトラック</span>
        </h1>
        <div>
          <figure><img src="/assets/images/music-soundtrack.jpg" alt="ノンクレジットOP"></figure>
        </div>
        <h2>
          <span>Original Soundtrack</span>
        </h2>
        <h3 class="is-size-1-mobile">
          <span>Composed & Arranged by Yutaka Yamada</span><br>
          <span>Performed by YVY</span>
        </h3>
        <p class="is-size-2 is-size-3-mobile">
          発売日：2020年9月23日(水)<br>￥3,000+税 / AZRC-1137-1138
        </p>
        <div class="lyric-button">
          <a
            href="https://www.amazon.co.jp/dp/B08GFX5P83"
            target="_blank"
            rel="noopener"
          >
            <button class="is-size-2 is-size-3-mobile has-text-weight-bold">ご購入はこちら</button>
          </a>
        </div>
        <div class="tracklist has-text-weight-normal">
          <p class="is-family-oswald has-text-weight-bold is-size-3 is-size-5-mobile">DISC 1</p>
          <ol class="is-size-5 is-size-6-mobile">
            <li>G.P.</li>
            <li>Confidence Man</li>
            <li>Hustle and Bustle</li>
            <li>You Know ft. Quincy</li>
            <li>Our Love ft. Quincy</li>
            <li>Con Artist</li>
            <li>Mischief Abound</li>
            <li>Through the Night ft. Max</li>
            <li>Melancholy</li>
            <li>Riverwalk</li>
            <li>A Scheme</li>
            <li>Cleanse</li>
            <li>Encore</li>
            <li>I'll Keep You ft. Emarie</li>
            <li>Last Train</li>
            <li>Someday ft. Emarie</li>
          </ol>
        </div>
        <div class="tracklist has-text-weight-normal">
          <p class="is-family-oswald has-text-weight-bold is-size-3 is-size-5-mobile">DISC 2</p>
          <ol class="is-size-5 is-size-6-mobile">
            <li>Soirée</li>
            <li>Free and Unbound</li>
            <li>My Island</li>
            <li>Confrontation</li>
            <li>Nonbasic</li>
            <li>Goner</li>
            <li>Homesick</li>
            <li>A Night Out</li>
            <li>The Setup</li>
            <li>Circles</li>
            <li>An Old Painting</li>
            <li>On the Clock</li>
            <li>Precious Past</li>
            <li>Warmth</li>
            <li>By the Sea</li>
            <li>Goodbye For Now</li>
            <li>Unforeseen</li>
            <li>The Honest Life</li>
            <li>Someday (Piano Ver.)</li>
          </ol>
        </div>
      </section>
    </div>
    <transition name="slide-up">
      <gp-modal v-if="hash === 'lyric'">
        <section class="lyric">
          <figure>
            <img src="/assets/images/music-lyric.jpg" alt="The Great Pretender 邦訳">
          </figure>
        </section>
      </gp-modal>
      <gp-modal v-else-if="hash">
        <video-player :videoId="hash"/>
      </gp-modal>
    </transition>
  </div>
</template>

<style lang="scss" scoped>
.gp-music {
  .contents-container {
    @include is-not-mobile  {
      max-width: 60rem;
      padding: 0 2rem;
      margin: auto;
    }
  }
  .page-title {
    @include is-mobile {
      margin-bottom: 2.5rem;
    }
  }
  section {
    @include is-mobile {
      margin-bottom: 2.5rem;
    }
    @include is-not-mobile {
      margin-bottom: 4.5rem;
    }
    h1 {
      color: $pink;
      background-color: $black;
      line-height: 2rem;
      @include is-mobile {
        margin: 0 1rem 1.25rem;
      }
      @include is-not-mobile {
        width: 22rem;
        margin: auto;
      }
    }
    h2 {
      @include is-mobile {
        font-size: 1.875rem;
        margin: 0 1rem;
        line-height: 2.25rem;
      }
      @include is-not-mobile {
        font-size: 2.5rem;
        margin: 1.5rem;
        line-height: 3rem;
      }
    }
    h3 {
      @include is-not-mobile {
        font-size: 1.875rem;
        margin: 0 1.5rem 2.5rem;
        line-height: 2.25rem;
      }
      @include is-mobile {
        margin: .5rem 1rem 2rem;
      }
    }
    .video {
      background-color: $black;
      margin: 1.5rem auto;
      @include is-mobile {
        width: calc(100% - 3rem);
      }
      @include is-not-mobile {
        width: 25rem;
      }
    }
    .lyric-button {
      @include is-mobile {
        margin-top: 1.5rem;
      }
      @include is-not-mobile {
        margin-top: 3rem;
      }
      button {
        width: 20rem;
        height: 3.75rem;
        cursor: pointer;
        background-color: $white;
        border-radius: 10rem;
        border: solid 4px $black;
        min-width: 18.75rem;
        height: 3.75rem;
        padding: 0 1.5rem;
      }
    }
  }
  .soundtrack {
    figure {
      margin: 1.5rem auto;
      width: 327px;
      @include is-not-mobile {
        margin: 2rem auto;
        width: 22rem;
      }
    }
    .lyric-button {
      margin-top: 1.5rem;
    }
  }
  .tracklist {
    margin: 1rem;
    @include is-not-mobile {
      margin: 2rem;
    }
    p {
      margin-bottom: .5rem;
    }
    ol {
      list-style: none;
      padding: 0;
      margin: 0;
      /*display: flex;
      flex-direction: column;
      justify-content: center;*/
      text-align: center;
      counter-reset: disc1;
      li {
        margin: auto;
        &:before {
          counter-increment: disc1;
          content: '0' counter(disc1);
          margin-right: 1rem;
        }
        &:nth-of-type(9) ~ li:before {
          content: counter(disc1);
        }
      }
    }
  }
  .lyric {
    margin: 0;
    background: rgba(187, 230, 63, .95);
    pointer-events: none;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 100%;
    * {
      pointer-events: auto;
    }
    figure {
      @include is-mobile {
        width: calc(100% - 3rem);
      }
      @include is-not-mobile {
        max-width: 37.5rem;
        margin: 5rem auto;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/page/music.vue